import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { appsignal } from '../appsignal';

@Injectable()
export class AppsignalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      console.error(error);
      return;
    }
    if (error instanceof Error) {
      appsignal.sendError(error);
    }
    console.error(error);
  }
}
